import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './SalePageLayout.module.css';

const SalePageLayout = ({ viewSize, displaySocialBanner, children }) => (
  <div
    className={classNames(viewSize, {
      [styles.socialEcomm]: displaySocialBanner,
    })}
  >
    {children}
  </div>
);

SalePageLayout.propTypes = {
  viewSize: PropTypes.string.isRequired,
  displaySocialBanner: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default SalePageLayout;
